import React, { RefObject } from "react"
import type { DefaultDocumentsCommandsPanelTourTargets } from "../../commandsPanels/DefaultDocumentsCommandsPanelV3"
import { TourStep } from "../Tour"
import * as FFIcons from "../../../libs/corporate/icons/outlined/other/FileAndFolderCollection"
import * as ActionIcons from "../../../libs/corporate/icons/outlined/editor/ActionCollection"
import { LeftIcon, RightIcon } from "../../../libs/corporate/icons/outlined/directions/ArrowsInCircleCollection"
import * as MailIcons from "../../../libs/corporate/icons/outlined/other/MailCollection"
import * as MainIcons from "../../../libs/corporate/icons/outlined/action/MainCollection"
import * as RotationIcons from "../../../libs/corporate/icons/outlined/directions/RotationCollection"
import { EmptySquareIcon } from "../../../libs/corporate/icons/outlined/suggested/SquareCollection"
import { AdditionalIcon } from "../../../libs/corporate/icons/outlined/other/FileAndFolderCollection"
import { returnStatusIcon } from "../../../system/functions/returnStatusIcon"

export interface InventorySvedPluginViewTourRefs {
    grid: RefObject<HTMLDivElement>
    detailsTabs: RefObject<HTMLDivElement>
}

export const getInventorySvedDocumentCommandsPanelTourSteps = (targets: DefaultDocumentsCommandsPanelTourTargets): TourStep[] => [
    {
        target: () => targets.commandsPanel,
        description: (
            <div>
                Панель содержит стандартные команды управления:
                <div style={{display: "flex", alignItems: "center", margin: "5px", gap: "10px"}}>
                    <FFIcons.FilePlusIcon /> Добавить запись
                </div>
                <div style={{display: "flex", alignItems: "center", margin: "5px", gap: "10px"}}>
                    <ActionIcons.HighlightIcon /> Редактировать запись
                </div>
                <div style={{display: "flex", alignItems: "center", margin: "5px", gap: "10px"}}>
                    <RightIcon /> Провести документ
                </div>
                <div style={{display: "flex", alignItems: "center", margin: "5px", gap: "10px"}}>
                    <LeftIcon /> Отменить документ
                </div>
                <div style={{display: "flex", alignItems: "center", margin: "5px", gap: "10px"}}>
                    <ActionIcons.CopyIcon /> Копировать
                </div>
                <div style={{display: "flex", alignItems: "center", margin: "5px", gap: "10px"}}>
                    <MailIcons.PrinterIcon /> Печать
                </div>
                <div style={{display: "flex", alignItems: "center", margin: "5px", gap: "10px"}}>
                    <MainIcons.Delete2Icon /> Удалить
                </div>
                <div style={{display: "flex", alignItems: "center", margin: "5px", gap: "10px"}}>
                    <MainIcons.DeleteIcon /> Восстановить
                </div>
                <div style={{display: "flex", alignItems: "center", margin: "5px", gap: "10px"}}>
                    <MainIcons.SearchIconPanel /> Поиск
                </div>
                <div style={{display: "flex", alignItems: "center", margin: "5px", gap: "10px"}}>
                    <RotationIcons.RotationRightIcon /> Обновить
                </div>
                <div style={{display: "flex", alignItems: "center", margin: "5px", gap: "10px"}}>
                    <EmptySquareIcon /> <AdditionalIcon /> Групповая обработка
                </div>
                <div style={{display: "flex", alignItems: "center", margin: "5px", gap: "10px"}}>
                    <MainIcons.MenuIcon /> Дополнительные действия
                </div>
            </div>
        ),
        placement: "bottom",
    },
    {
        target: () => targets.datePeriodPanel,
        description: `Фильтр "Период" со встроенным календарём: по умолчанию показывает документы за последнюю неделю`,
        placement: "bottom",
    },
    {
        target: () => targets.statusSelect,
        description: (
            <div>
                Фильтр по статусу, показывает ведомости в статусе:
                <ul>
                    <li>Все</li>
                    <li>Сохранённые</li>
                    <li>Отработанные</li>
                    <li>Удалённые</li>
                </ul>
            </div>
        ),
        placement: "bottom",
    },
    {
        target: () => targets.searchPanel,
        description: `Кнопка "Поиск" фильтрует документы по наличию ведомости в сводной инвентаризации`,
        placement: "bottom",
    },
]

export const getInventorySvedPluginViewTourSteps = (refs: InventorySvedPluginViewTourRefs, documentCommandsPanelTourSteps: TourStep[]): TourStep[] => [
    ...documentCommandsPanelTourSteps.slice(0, 4),
    {
        target: () => refs.grid.current,
        description: (
            <div>
                Это таблица со списком сводных инвентаризаций.
                <div>
                    В колонке "СД", обозначение иконок:
                    <div style={{display: "flex", alignItems: "center", margin: "5px", gap: "10px"}}>
                        {returnStatusIcon("draft" as any)} Черновик
                    </div>
                    <div style={{display: "flex", alignItems: "center", margin: "5px", gap: "10px"}}>
                        {returnStatusIcon("proc" as any)} Отработан
                    </div>
                    <div style={{display: "flex", alignItems: "center", margin: "5px", gap: "10px"}}>
                        {returnStatusIcon("del" as any)} Удалён
                    </div>
                </div>
            </div>
        ),
        placement: "top",
    },
    {
        target: () => refs.detailsTabs.current,
        description: (
            <div>
                Панель отображает детализацию выбранного документа:
                <ul>
                    <li>"Позиции": список товаров в ведомости</li>
                    <li>"КИЗ": список КИЗ товаров в ведомости и их статусы</li>
                    <li>"Короб": список маркированных коробов в ведомости</li>
                </ul>
            </div>
        ),
        placement: "top",
    },
]
